import sizeComparison from "assets/icons/psp/illustration-multiple-sites.svg";
import ctaMan from "assets/images/psp/inlineCTA.jpg";
import AnnAlarcon from "assets/images/psp/review-ann.png";
import FemaleAvatar from "assets/images/psp/femaleavatar.jpg";
import SMurphy from "assets/images/psp/review-murphy.png";
import CarRv from "assets/images/psp/relatedContentImages/car-storage-1-jpg.webp";
import CarStorage from "assets/images/psp/relatedContentImages/car-storage.webp";
import OutDoorParking from "assets/images/psp/relatedContentImages/outdoorparking.webp";
import SportsCar from "assets/images/psp/relatedContentImages/sports-car-storage.webp";
import illustrationSearch from "assets/images/psp/illustration-search.svg";
import HeaderBackgroundDesktop from "assets/images/psp/hero/car-hero.webp";
import HeaderBackgroundMobile from "assets/images/psp/hero/car-header-mobile.webp";
import HeaderBackgroundTablet from "assets/images/psp/hero/car-header-tablet.webp";
import { storageCategories } from "../utils/getPSPLinks";

const CarFAQs = [
	{
		question: "Can you store a car in a storage unit?",
		answer: `Yes, most storage facilities allow vehicles and offer specialized car storage options with varying levels of security and weather protection.`
	},
	{
		question: "Is a 10x20 storage unit car-friendly?",
		answer: `Yes, a 10x20 unit (200 sq ft) can fit most standard cars, compact SUVs, and motorcycles, but it may be tight for larger vehicles like full-size trucks or large SUVs. Measure your vehicle's length and width to confirm fit.`
	},
	{
		question: "What is trickle charging, and is it necessary?",
		answer: `A trickle charger is a charger for car batteries that can be left on the battery for long periods of time. A trickle charger keeps your battery from losing all charge as well as from becoming overcharged. Trickle chargers run between $15-$100, depending on how many amps you need. The longer your car is in storage, the more amps the battery will need.

It may be safest to remove the battery and place it on a trickle charger in your own home, rather than leaving it in the storage unit.
`
	},
	{
		question:
			"Do I need a special kind of insurance coverage for my car in storage?",
		answer: `Though you may not be driving your car for a while, it must remain registered and insured to be in a storage unit. Talk with your insurance agent about switching to a less expensive temporary coverage plan, as vehicle insurance laws vary from state to state. Common coverage plans for cars in storage are comp-only and seasonal. 

If you park an uninsured vehicle in a storage unit, you run the risk of receiving a citation or having your license suspended. Don’t forget to switch your insurance when your car is back on the road!
`
	}
];
const carHerodescription = `
Protect your vehicle and reclaim your space with car storage close to home. Whether you’re traveling far from home, growing your [car collection](https://storage.com/blog/sports-car-storage/), or looking to free up space in your driveway, there’s a car storage facility for you. Automobile storage provides car owners with the space, protection, and peace of mind that street parking can't, with the flexibility to choose from a wide range of car storage parking options.
`;

export const PSPCarContent = {
	type: "Car",
	sections: [
		{
			title: "Car Storage hero",
			noPadding: true,
			modules: [
				{
					type: "hero-section",
					props: {
						title: "Find the Top Car Storage Units",
						description: carHerodescription,
						searchPlaceholder: "Search by city, state, or zip...",
						buttonText: "Find Car Storage",
						heroImages: {
							desktop: HeaderBackgroundDesktop,
							tablet: HeaderBackgroundTablet,
							mobile: HeaderBackgroundMobile
						},
						heroAltText: "Car Storage Hero Image"
					}
				}
			]
		},
		{
			title: "Car Storage : Content Section",
			noPadding: true,
			modules: [
				{
					type: "content-section",
					props: {
						title: "Secure Car Storage Options",
						description:
							"There are different types of storage for cars that offer [unique benefits to car owners](https://storage.com/blog/the-benefits-of-auto-storage/) based on location, amenities, and length of stay. Find the best option for your needs and budget with our quick guide.",
						isColumnWise: true,
						background: "white",
						content: [
							{
								id: "1",
								value: `
**Indoor Car Storage:**\n\n
Large garage facilities accommodate multiple vehicles with full weather protection and theft deterrence. Many locations offer battery maintenance services to keep your car road-ready. 
\n\n***Best for:*** medium-term storage, a balance between advanced protection and affordability.`
							},
							{
								id: "2",
								value: `**Outdoor Car Storage:**\n\n
The most budget-friendly option is usually paired with gated security and high fencing. Your vehicle remains exposed to weather but benefits from controlled access and surveillance.
\n\n***Best for:***	short-term storage or budget-conscious car owners.`
							},
							{
								id: "3",
								value: `**Drive Up Storage:**\n\n
Individual garage-style units provide maximum security and privacy. Complete protection from elements, theft, and damage with convenient drive-up access for easy vehicle retrieval.
\n\n***Best for:*** medium to long-term storage where premium protection is a must. 

								`
							}
						]
					}
				}
			]
		},
		{
			title: "Car Storage : Size Comparison",
			noPadding: true,
			modules: [
				{
					type: "size-comparison",
					props: {
						title: "What size storage unit do I need for a car?",
						description:
							"When it comes to car storage, you have options. Storage facilities offer an array of sizes that can accommodate everything from your family mini van, to that classic sports car you can’t part ways with.",
						image: sizeComparison,
						sizes: [
							{
								id: "10x15",
								label: "10x15",
								title: "10' Wide x 15' Long",
								description:
									" - Perfect for compact or subcompact vehicles Honda Civic, Toyota Corolla\n" +
									" - These size storage units can handle cars and automobiles under 14 feet in length"
							},
							{
								id: "10x20",
								label: "10x20",
								title: "10' Wide x 20' Long",
								description:
									" - You’ve found the sweet spot with a 10x20 car storage unit.\n" +
									" - This space will fit most standard-sized vehicles such as a Honda Accord or Nissan Altima, with a little room to spare for tools, or even a handy trickle charger or battery tender."
							},
							{
								id: "10x25",
								label: "10x25",
								title: "10' Wide x 25' Long",
								description:
									" - This is a great option for longer cars like the Chevy Impala, standard trucks like a Toyota Tacoma, or even a small Class B RV with shorter height."
							},
							{
								id: "10x30",
								label: "10x30",
								title: "10' Wide x 30' Long",
								description:
									" - As the longest common car storage unit size option, this large unit is ideal for storing large SUVS like a Ford Expedition, trucks with elongated beds and many van models."
							}
						],
						footer: "Always measure vehicle length, width, and height before reserving. Indoor and climate-controlled units offer added protection for classic or high-value cars."
					}
				}
			]
		},
		{
			title: "Car Storage : Rich Content",
			noPadding: true,
			modules: [
				{
					type: "video-content",
					props: {
						title: "How To Store a Car Long Term",
						description:
							"If you’re planning on [storing your car for months](https://blog.storage.com/winterize-your-car-for-self-storage/) on end, there are a few things you need to consider to keep your vehicle ready for its next joyride.",
						mediaType: "video",
						mediaUrl: "R4IuifUmqwE",
						videoTitle:
							"How To Prepare Your Car For Long-Term Storage"
					}
				}
			]
		},
		{
			title: "Car Storage Inline CTA",
			noPadding: true,
			modules: [
				{
					type: "inline-cta",
					props: {
						storageType: "Car",
						subheading: "Make a free reservation in minutes!",
						searchPlaceholder: "Search by city, state, or zip...",
						searchButtonText: "Find Storage",
						image: ctaMan,
						imageAltText: "inlineCTA image",
						background: "white"
					}
				}
			]
		},
		{
			title: "Car Storage Reviews",
			noPadding: true,
			modules: [
				{
					type: "reviews",
					props: {
						title: "Storage.com has 4.4 out of 5 star rating on",
						testimonials: [
							{
								body: "My Storage.com representative was very helpful and patient with me, working through to find the best location and price.",
								author: "Jess",
								title: "Very helpful.",
								imageSrc: AnnAlarcon
							},
							{
								body: "Storage.com did an excellent job helping me find a storage facility at a great price. Better than the price that I found. ",
								author: "Alison",
								title: "Storage facility",
								imageSrc: FemaleAvatar
							},
							{
								body: "Storage.com found me a spot immediately for half the price I had found in my search. Very courteous representatives.",
								author: "Robert Fulton",
								title: "Excellent!",
								imageSrc: SMurphy
							}
						]
					}
				}
			]
		},
		{
			title: "Car Storage FAQ",
			noPadding: true,
			modules: [
				{
					type: "faq",
					props: {
						title: "Car Storage FAQs",
						faqs: CarFAQs
					}
				}
			]
		},
		{
			title: "Car Storage Related Content",
			noPadding: true,
			modules: [
				{
					type: "related-content",
					props: {
						heading: "Learn More About Automotive Storage",
						unitCards: [
							{
								category: "Recreational Storage",
								content:
									"What Size Storage Unit for Your Car? A Comprehensive Guide",
								date: "July 30, 2025",
								image: CarRv,
								url: "https://www.storage.com/blog/car-storage-unit-size/"
							},
							{
								category: "Recreational Storage",
								content:
									"Vehicle Storage: Where and How to Store a Car",
								date: "July 30, 2025",
								image: CarStorage,
								url: "https://www.storage.com/blog/the-complete-guide-to-vehicle-storage/"
							},
							{
								category: "Recreational Storage",
								content:
									"How Much Does Vehicle Storage Cost? Comprehensive Guide with Price Comparisons",
								date: "September 8, 2025",
								image: OutDoorParking,
								url: "https://www.storage.com/blog/cost-of-car-storage/"
							},
							{
								category: "Recreational Storage",
								content: "Sports Car Storage",
								date: "December 17, 2025",
								image: SportsCar,
								url: "https://www.storage.com/blog/sports-car-storage/"
							}
						]
					}
				}
			]
		},
		{
			title: "Car  PSP Links",
			noPadding: true,
			modules: [
				{
					type: "psp-links",
					props: {
						background: "white",
						storageGridContent: {
							title: "More Ways to Store",
							image: illustrationSearch,
							storageTypes: storageCategories.car
						}
					}
				}
			]
		},
		{
			title: "Car Storage Near You",
			noPadding: true,
			modules: [
				{
					type: "nearby-cities",
					props: {
						pageType: "PSP",
						background: "light-blue"
					}
				}
			]
		}
	]
};

export default PSPCarContent;
